module.exports = __webpack_public_path__ + "static/img/5_1_1.27155c43.jpg";